// Input.jsx

import React from "react";

const Input = ({ name, label, value, onChange, type = "text", options = [] }) => {
    const peerPlaceholder = type == 'textarea' ? 'peer-placeholder-shown:top-5' : 'peer-placeholder-shown:top-1/2';

    const roundedSize = type == 'textarea' ? 'rounded-2xl' : 'rounded-full';

    const inputClasses = roundedSize + " py-3 px-4 peer  border-none w-full bg-transparent placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0"
    console.debug(name, value)
    return (
        <label
            htmlFor={name}
            className={`${roundedSize} relative block  border border-gray-200 shadow-sm focus-within:border-mlime focus-within:ring-1 focus-within:ring-mlime mb-5`}
        >
           {
                type === 'textarea' ? (
                    <textarea
                        name={name}
                        id={name}
                        cols="30"
                        rows="10"
                        value={value}
                        onChange={onChange}
                        placeholder={label}
                        className={inputClasses}
                    />
                ) : type === 'select' ? (
                    <select
                        name={name}
                        id={name}
                        value={value}
                        onChange={onChange}
                        className={inputClasses}
                    >
                        {/* <option value="" disabled>{label}</option> */}
                        {options.map((option, index) => (
                            <option key={index} value={option.id}>
                                {option.name}
                            </option>
                        ))}
                    </select>
                ) : (
                    <input
                        type={type}
                        name={name}
                        id={name}
                        placeholder={label}
                        value={value}
                        onChange={onChange}
                        className={inputClasses}
                    />
                )
            }

            <span
                className={`pointer-events-none font-bold absolute start-4 top-0 -translate-y-1/2 bg-white p-0.5 text-xs text-gray-700 transition-all  peer-placeholder-shown:text-sm peer-focus:top-0 peer-focus:text-xs ${peerPlaceholder}`}
            >
                {label}
            </span>
        </label>
    );
};

export default Input;
